export default __webpack_public_path__ + "locales/sk/FillPDFDialog.json?hash=b196301a0d879e2455001cd7ea270def";